// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from "react";
import {Link} from "react-router-dom";
import {Button, Checkbox, Col, Form, Input, Result, Row, Spin, Tabs} from "antd";
import {LockOutlined, UserOutlined} from "@ant-design/icons";
import * as AuthBackend from "../../services/AuthBackend";
import * as ApplicationBackend from "../../services/ApplicationBackend";
import * as Provider from "../../widget/Provider";
import * as Util from "../../utils/Util";
import * as Setting from "../../conf/Setting";
import {GithubLoginButton, GoogleLoginButton} from "react-social-login-buttons";
import FacebookLoginButton from "../../components/3rdLoginButton/FacebookLoginButton";
import QqLoginButton from "../../components/3rdLoginButton/QqLoginButton";
import DingTalkLoginButton from "../../components/3rdLoginButton/DingTalkLoginButton";
import GiteeLoginButton from "../../components/3rdLoginButton/GiteeLoginButton";
import WechatLoginButton from "../../components/3rdLoginButton/WechatLoginButton";
import WeiboLoginButton from "../../components/3rdLoginButton/WeiboLoginButton";
import i18next from "i18next";
import LinkedInLoginButton from "../../components/3rdLoginButton/LinkedInLoginButton";
import WeComLoginButton from "../../components/3rdLoginButton/WeComLoginButton";
import LarkLoginButton from "../../components/3rdLoginButton/LarkLoginButton";
import GitLabLoginButton from "../../components/3rdLoginButton/GitLabLoginButton";
import AdfsLoginButton from "../../components/3rdLoginButton/AdfsLoginButton";
import BaiduLoginButton from "../../components/3rdLoginButton/BaiduLoginButton";
import AlipayLoginButton from "../../components/3rdLoginButton/AlipayLoginButton";
import CasdoorLoginButton from "../../components/3rdLoginButton/CasdoorLoginButton";
import InfoflowLoginButton from "../../components/3rdLoginButton/InfoflowLoginButton";
import AppleLoginButton from "../../components/3rdLoginButton/AppleLoginButton";
import AzureADLoginButton from "../../components/3rdLoginButton/AzureADLoginButton";
import SlackLoginButton from "../../components/3rdLoginButton/SlackLoginButton";
import SteamLoginButton from "../../components/3rdLoginButton/SteamLoginButton";
import CustomGithubCorner from "../../components/common/CustomGithubCorner";
import {CountDownInput} from "../../components/common/CountDownInput";
import {JSEncrypt} from "jsencrypt";
import SelectLanguageBox from "../../components/common/SelectLanguageBox";
import * as PasswordPolicyBackend from "../../services/PasswordPolicyBackend";
import Captcha from "../../components/common/Captcha";
import GlobalContext from "../../context/GlobalContext";
import iconfont from "../../assets/font/appfonts/iconfont.json";
import * as IconFont from "../../components/common/IconFont";
import "../../assets/styles/login/LoginPage.less";
import {authInfo} from "../../widget/Provider";

const isSmallScreen = window.screen.availWidth <= 1366 ? true : false;

const WeChat = {
  scope: "snsapi_login",
  mpScope: "snsapi_userinfo",
};

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    const rememberUsername = window.localStorage.getItem("rememberUsername");
    const rememberPassword = window.localStorage.getItem("rememberPassword");
    this.setState({
      rememberUsername: rememberUsername === "true" ? true : false,
      rememberPassword: rememberPassword === "true" ? true : false,
    });

    let username = null;
    if (rememberUsername === "true") {
      username = Setting.getCookie("username");
    }
    let password = null;
    if (rememberPassword === "true") {
      password = Setting.getCookie("u_a_p_w_d");
    }

    this.state = {
      classes: props,
      type: props.type,
      applicationId:
        props.applicationId !== undefined
          ? props.applicationId
          : props.match === undefined
            ? null
            : props.match.params.applicationId,
      owner:
        props.owner !== undefined
          ? props.owner
          : props.match === undefined
            ? null
            : props.match.params.owner,
      application: null,
      mode:
        props.mode !== undefined
          ? props.mode
          : props.match === undefined
            ? null
            : props.match.params.mode, // "signup" or "signin"
      isCodeSignin: false,
      isPasswordSignin: true,
      isPhoneSignin: false,
      isEmailSignin: false,
      msg: null,
      username: username,
      cookiPassword: password,
      validEmailOrPhone: false,
      validEmail: false,
      validPhone: false,
      casParamException: false,
      attentionShow: false,
      attentionMobileShow: false,
      wechatProvider: null,
      wechatOfficialBind: false,
      signinWay: "account",
      wechatOfficialSms: false,
      pageLoading: true,
      rememberUsername: rememberUsername === "true" ? true : false,
      rememberPassword: rememberPassword === "true" ? true : false,
    };

    if (this.state.type === "cas" && props.match?.params.casApplicationName !== undefined) {
      this.state.owner = props.match?.params.owner;
      this.state.applicationId = props.match?.params.casApplicationName;

      const casParams = Util.getCasParameters();
      if (casParams.service === "") {
        this.state.casParamException = true;
      }
    }
  }

  formRef = React.createRef();
  captchaRef = React.createRef();

  isMobile() {
    return Setting.isMobile();
    // return navigator.userAgent.match(/(iphone|iPod|Android|ios|iPad|AppleWebKit.*Mobile.*)/i);
  }

  async UNSAFE_componentWillMount() {
    if (!this.props.isPreview) {
      this.props.history.block((location) => {
        if (Setting.getENVIR() === "wxh5" && location.pathname === "/") {
          return false;
        }
        return true;
      });
    }

    let applicationRes = null;
    const params = new URLSearchParams(window.location.search);
    const loginUrl = Util.decodeUrl(params.get("login_url"));
    if (!loginUrl) {
      if (this.state.type === "login" || this.state.type === "cas") {
        applicationRes = this.getApplication();
      } else if (this.state.type === "code") {
        applicationRes = await this.getApplicationLogin();
      } else if (this.state.type === "saml") {
        applicationRes = this.getSamlApplication();
      } else {
        Util.showMessage("error", `Unknown authentication type: ${this.state.type}`);
      }
    } else {
      const _url = new URL(loginUrl);

      const type = this.getWechatResponseType(_url.search);

      if (type === "login" || type === "cas") {
        applicationRes = this.getApplication();
      } else if (type === "code") {
        applicationRes = await this.getApplicationLogin(_url.searchParams);
      } else if (type === "saml") {
        applicationRes = this.getSamlApplication();
      } else {
        Util.showMessage("error", `Unknown authentication type: ${this.state.type}`);
      }
    }

    if (this.props.account && this.props.account.organization.needActivation && !this.props.account.isActive) {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      if (!code) {
        const encode = Util.encodeUrl(window.location.href);
        Setting.goToActivate(this, applicationRes, `?login_url=${encode}`);
      }
    }

    const code = params.get("code");
    if (!code || !applicationRes) {
      return;
    }

    const innerParams = this.getInnerParams();
    const applicationId = innerParams.get("application");
    const providerId = innerParams.get("provider");
    const method = innerParams.get("method");
    const samlRequest = innerParams.get("SAMLRequest");
    const casService = innerParams.get("service");

    const redirectUri = `${window.location.origin}/login`;

    const body = {
      type: this.getResponseType(),
      application: applicationId,
      provider: providerId,
      code: code,
      samlRequest: samlRequest,
      // state: innerParams.get("state"),
      state: applicationId,
      redirectUri: redirectUri,
      method: method,
    };

    if (this.getResponseType() === "cas") {
      // user is using casdoor as cas sso server, and wants the ticket to be acquired
      AuthBackend.loginCas(body, {"service": casService}).then((res) => {
        if (res.status === "ok") {
          let msg = i18next.t("login:Logged in successfully.");
          if (casService === "") {
            // If service was not specified, Casdoor must display a message notifying the client that it has successfully initiated a single sign-on session.
            msg += i18next.t("login:Now you can visit apps protected.");
          }
          Util.showMessage("success", msg);

          if (casService !== "") {
            const st = res.data;
            const newUrl = new URL(casService);
            newUrl.searchParams.append("ticket", st);
            window.location.href = newUrl.toString();
          }
        } else {
          if (Setting.getENVIR() === "wxh5" && res.data2 === "not sign up") {
            Setting.showMessage("error", "未绑定");
            setTimeout(() => {
              this.setState({
                wechatOfficialBind: true,
              });
            }, 500);
          } else {
            Setting.showResponseMessage(res.msg);
            setTimeout(() => {
              const backUrl = Util.decodeUrl(params.get("login_url"));
              window.location.href = backUrl;
            }, 1000);
          }
        }
      });
      return;
    }

    const that = this;
    // OAuth
    const oAuthParams = Util.getOAuthGetParameters(innerParams);
    const concatChar = oAuthParams?.redirectUri?.includes("?") ? "&" : "?";
    AuthBackend.login(body, oAuthParams)
      .then((res) => {
        if (res.status === "ok") {
          const responseType = this.getResponseType();
          Util.showMessage("success", "登录成功");
          if (responseType === "login") {

            const link = Setting.getFromLink();
            Setting.goToLink(link);
          } else if (responseType === "code") {
            const code = res.data;
            setTimeout(() => {
              Setting.goToLink(`${oAuthParams.redirectUri}${concatChar}code=${code}&state=${oAuthParams.state}`);
            }, 300);
            // Util.showMessage("success", `Authorization code: ${res.data}`);
          } else if (responseType === "token" || responseType === "id_token") {
            const token = res.data;
            Setting.goToLink(`${oAuthParams.redirectUri}${concatChar}${responseType}=${token}&state=${oAuthParams.state}&token_type=bearer`);
          } else if (responseType === "link") {
            const from = innerParams.get("from");
            Setting.goToLinkSoft(this, from, that.props.location.pathname);
          } else if (responseType === "saml") {
            const SAMLResponse = res.data;
            const redirectUri = res.data2;
            Setting.goToLink(`${redirectUri}?SAMLResponse=${encodeURIComponent(SAMLResponse)}&RelayState=${oAuthParams.relayState}`);
          }
        } else {
          if (Setting.getENVIR() === "wxh5" && res.data2 === "not sign up") {
            Setting.showMessage("error", "此微信未绑定用户，请先绑定用户");
            setTimeout(() => {
              this.setState({
                wechatOfficialBind: true,
              });
            }, 1000);
          } else {
            Setting.showResponseMessage(res.msg);
            setTimeout(() => {
              const backUrl = Util.decodeUrl(params.get("login_url"));
              window.location.href = backUrl;
            }, 1000);
          }
        }
      });
  }

  getResponseType() {
    const authServerUrl = "";

    const innerParams = this.getInnerParams();
    const method = innerParams.get("method");
    if (method === "signup") {
      const realRedirectUri = innerParams.get("redirect_uri");
      // Casdoor's own login page, so "code" is not necessary
      if (realRedirectUri === null) {
        const samlRequest = innerParams.get("SAMLRequest");
        // cas don't use 'redirect_url', it is called 'service'
        const casService = innerParams.get("service");
        if (samlRequest !== null && samlRequest !== undefined && samlRequest !== "") {
          return "saml";
        } else if (casService !== null && casService !== undefined && casService !== "") {
          return "cas";
        }
        return "login";
      }

      let realRedirectUrl;
      try {
        realRedirectUrl = new URL(realRedirectUri).origin;
      } catch (error) {
        Setting.showMessage("error", error.message);
      }

      // For Casdoor itself, we use "login" directly
      if (authServerUrl === realRedirectUrl) {
        return "login";
      } else {
        const responseType = innerParams.get("response_type");
        if (responseType !== null) {
          return responseType;
        }
        return "code";
      }
    } else if (method === "link") {
      return "link";
    } else {
      return "unknown";
    }
  }

  getWechatResponseType(urlSearch) {
    const authServerUrl = "";

    const params = new URLSearchParams(urlSearch);
    const realRedirectUri = params.get("redirect_uri");
    // Casdoor's own login page, so "code" is not necessary
    if (realRedirectUri === null) {
      const samlRequest = params.get("SAMLRequest");
      // cas don't use 'redirect_url', it is called 'service'
      const casService = params.get("service");
      if (samlRequest !== null && samlRequest !== undefined && samlRequest !== "") {
        return "saml";
      } else if (casService !== null && casService !== undefined && casService !== "") {
        return "cas";
      }
      return "login";
    }

    let realRedirectUrl;
    try {
      realRedirectUrl = new URL(realRedirectUri).origin;
    } catch (error) {
      Setting.showMessage("error", error.message);
    }

    // For Casdoor itself, we use "login" directly
    if (authServerUrl === realRedirectUrl) {
      return "login";
    } else {
      const responseType = params.get("response_type");
      if (responseType !== null) {
        return responseType;
      }
      return "code";
    }
  }

  async getApplicationLogin(searchQeuryString = undefined) {
    const oAuthParams = Util.getOAuthGetParameters(searchQeuryString);
    const res = await AuthBackend.getApplicationLogin(oAuthParams);
    if (res.status === "ok") {
      this.setState({
        application: res.data,
      });
      window.localStorage.setItem("__APPLICATION__", JSON.stringify(res.data));
      const weChatItem = res.data.providers.find((providerItem) => providerItem.provider && providerItem.provider.type === "WeChat");
      if (weChatItem) {
        setTimeout(() => {
          if (!this.isMobile()) {
            // this.loadWeChatQRCode(weChatItem, res.data);
          }
        }, 500);
      }
    } else {
      this.setState({
        application: res.data,
        msg: res.msg,
      });
    }
    return res.data;
  }

  async getApplication() {
    if (this.state.applicationId === null) {
      return null;
    }

    const res = await ApplicationBackend.getApplicationById(Setting.Admin, this.state.applicationId);
    if (res.msg !== undefined) {
      Setting.showResponseMessage(res.msg);
    } else {
      // 重置logo图片
      this.setState({
        application: res,
      });
      window.localStorage.setItem("__APPLICATION__", JSON.stringify(res));

      const weChatItem = res.providers.find((providerItem) => providerItem.provider && providerItem.provider.type === "WeChat");
      if (weChatItem) {
        setTimeout(() => {
          if (!this.isMobile()) {
            // this.loadWeChatQRCode(weChatItem, res);
          }
        }, 500);
      }
    }
    return res;
  }

  async getSamlApplication() {
    if (this.state.applicationId === null) {
      return null;
    }
    const res = ApplicationBackend.getApplication(this.state.owner, this.state.applicationId);
    this.setState({
      application: res,
    });
    const weChatItem = res.providers.find((providerItem) => providerItem.provider && providerItem.provider.type === "WeChat");
    if (weChatItem) {
      setTimeout(() => {
        if (!this.isMobile()) {
          // this.loadWeChatQRCode(weChatItem, res);
        }
      }, 500);
    }
    window.localStorage.setItem("__APPLICATION__", JSON.stringify(res));
    return res;
  }

  getApplicationObj() {
    if (this.props.application !== undefined) {
      return this.props.application;
    } else {
      return this.state.application;
    }
  }

  getInnerParams = (urlSearch = undefined) => {
    const params = !urlSearch ? new URLSearchParams(location.search) : new URLSearchParams(urlSearch);
    const state = params.get("state");
    const queryString = Util.getQueryParamsFromState(state);
    return new URLSearchParams(queryString);
  };

  onUpdateAccount(account) {
    this.props.onUpdateAccount(account);
  }

  onFinish(formValues, updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck, captchaPass = true, user = undefined) {
    const application = this.getApplicationObj();
    const ths = this;

    if (this.state.isPasswordSignin && !captchaPass) {
      this.captchaRef.current.getCaptcha();
      return;
    }

    const values = Setting.deepCopy(formValues);

    AuthBackend.getPublicKey().then(resPubKey => {
      if (resPubKey.status === "ok") {
        // 密码加密
        const encrypt = new JSEncrypt();
        encrypt.setPublicKey(resPubKey.msg);
        if (this.state.cookiPassword !== values["password"]) {
          values["password"] = encrypt.encrypt(values["password"]);
        }
        if (values["password"] === false) {
          values["password"] = "";
        }

        // here we are supposed to judge whether casdoor is working as a oauth server or CAS server
        if (ths.state.type === "cas") {
          // cas
          const casParams = Util.getCasParameters();
          values["type"] = ths.state.type;
          values["phonePrefix"] = this.getApplicationObj().organizationObj === null ? "" : this.getApplicationObj().organizationObj.phonePrefix;

          AuthBackend.loginCas(values, casParams).then((res) => {
            if (res.status === "ok") {
              if (this.state.isPasswordSignin) {
                this.rememberAuthInfo({username: values["username"], password: values["password"]});
              }

              let msg = i18next.t("login:Logged in successfully.");
              if (casParams.service === "") {
                // If service was not specified, CAS MUST display a message notifying the client that it has successfully initiated a single sign-on session.
                msg += i18next.t("login:Now you can visit apps protected.");
              }
              if (casParams.service !== "") {
                const st = res.data;
                try {
                  const newUrl = new URL(casParams.service);
                  newUrl.searchParams.append("ticket", st);
                  Util.showMessage("success", msg);
                  window.location.href = newUrl.toString();
                } catch (error) {
                  Setting.showMessage("error", error.message);
                }
              } else {
                Util.showMessage("success", msg);
              }
            } else {
              Util.showMessage(
                "error",
                Setting.getResponseMessage(res.msg)
              );
            }
          });
        } else {
          // oauth
          const oAuthParams = Util.getOAuthGetParameters();
          if (
            oAuthParams !== null &&
						oAuthParams.responseType !== null &&
						oAuthParams.responseType !== ""
          ) {
            values["type"] = oAuthParams.responseType;
          } else {
            values["type"] = this.state.type;
          }

          values["phonePrefix"] = this.getApplicationObj().organizationObj === null ? "" : this.getApplicationObj().organizationObj.phonePrefix;

          if (oAuthParams !== null) {
            values["samlRequest"] = oAuthParams.samlRequest;
          }

          if (values["samlRequest"] !== null && values["samlRequest"] !== "" && values["samlRequest"] !== undefined) {
            values["type"] = "saml";
          }

          AuthBackend.login(values, oAuthParams).then((res) => {
            if (res.status === "ok") {
              const password = values["password"];

              const responseType = values["type"];
              let username = ths.state.isPasswordSignin ? values["username"] : "";
              username = user !== undefined ? user : username;

              if (this.state.isPasswordSignin) {
                this.rememberAuthInfo({username: username, password: values["password"]});
              }
              if (responseType === "login") {
                Util.showMessage("success", i18next.t("login:Logged in successfully."));

                PasswordPolicyBackend.checkPasswordNeedChange(application.organizationObj.owner, application.organizationObj.uid, application.organizationObj.uid, username, password)
                  .then(resCheck => {
                    const loginRedirectUri = Setting.getFromLink();
                    const pwdRemindRedirectUri = Util.encodeUrl(loginRedirectUri);
                    if (resCheck.data === true) {
                      Setting.goToLink(`/password/remind/${application.organizationObj.uid}/?msg=${JSON.stringify(resCheck.msg)}&skip=${resCheck.data2 === true ? 1 : 0}&redirect_uri=${pwdRemindRedirectUri}`);
                      updateSkipPasswordCheck(false);
                      updatePasswordCheckMsg(resCheck.msg);
                      if (resCheck.data2 === true) {
                        updateShipChangePassword(true);
                      }
                    } else if (resCheck.msg !== undefined && resCheck.msg !== "") {
                      Setting.getResponseMessage(resCheck.msg);
                    } else {
                      Setting.goToLink(loginRedirectUri);
                    }
                  });
              } else if (responseType === "code") {
                const code = res.data;
                const concatChar = oAuthParams?.redirectUri?.includes("?") ? "&" : "?";

                if (Setting.hasPromptPage(application)) {
                  AuthBackend.getAccount("").then((res) => {
                    let account = null;
                    if (res.status === "ok") {
                      account = res.data;
                      // 设置默认title
                      res.data2.displayName = "统一身份认证平台";
                      account.organization = res.data2;

                      PasswordPolicyBackend.checkPasswordNeedChange(application.organizationObj.owner, application.organizationObj.uid, application.organizationObj.uid, username, password)
                        .then(resCheck => {
                          let loginRedirectUri = "";
                          let pwdRemindRedirectUri = "";
                          if (Setting.isPromptAnswered(account, application)) {
                            loginRedirectUri = `${oAuthParams.redirectUri}${concatChar}code=${code}&state=${oAuthParams.state}`;
                            pwdRemindRedirectUri = Util.encodeUrl(loginRedirectUri);
                          } else {
                            loginRedirectUri = `/prompt/${application.uid}?redirectUri=${oAuthParams.redirectUri}&code=${code}&state=${oAuthParams.state}`;
                            pwdRemindRedirectUri = Util.encodeUrl(`${window.location.origin}/${loginRedirectUri}`);
                          }
                          if (resCheck.data === true) {
                            Setting.goToLink(`/password/remind/${application.organizationObj.uid}/?msg=${JSON.stringify(resCheck.msg)}&skip=${resCheck.data2 === true ? 1 : 0}&redirect_uri=${pwdRemindRedirectUri}`);
                            updateSkipPasswordCheck(false);
                            updatePasswordCheckMsg(resCheck.msg);
                            if (resCheck.data2 === true) {
                              updateShipChangePassword(true);
                            }
                          } else if (resCheck.msg !== undefined && resCheck.msg !== "") {
                            Setting.getResponseMessage(resCheck.msg);
                          } else {
                            if (Setting.isPromptAnswered(account, application)) {
                              Setting.goToLink(
                                `${oAuthParams.redirectUri}${concatChar}code=${code}&state=${oAuthParams.state}`
                              );
                            } else {
                              Setting.goToLink(
                                `/prompt/${application.uid}?redirectUri=${oAuthParams.redirectUri}&code=${code}&state=${oAuthParams.state}`
                              );
                            }
                          }
                        });
                    } else {
                      Setting.showMessage(
                        "error",
                        Setting.getResponseMessage(res.msg)
                      );
                    }
                  });
                } else {
                  AuthBackend.getAccount("").then((res) => {
                    if (res.status === "ok") {
                      const loginRedirectUri = `${oAuthParams.redirectUri}${concatChar}code=${code}&state=${oAuthParams.state}`;
                      const pwdRemindRedirectUri = Util.encodeUrl(loginRedirectUri);

                      if (ths.state.isPhoneSignin &&
                          (Setting.getENVIR() === "wxh5" && !res.data.wechatofficial ||
                          Setting.getENVIR() !== "wxh5" && !res.data.wechat)) {
                        Setting.goToLink(`/account?login_redirect_url=${pwdRemindRedirectUri}&currentTab=accountInfo`);
                        return;
                      }

                      PasswordPolicyBackend.checkPasswordNeedChange(application.organizationObj.owner, application.organizationObj.uid, application.organizationObj.uid, username, password)
                        .then(resCheck => {
                          if (resCheck.data === true) {
                            Setting.goToLink(`/password/remind/${application.organizationObj.uid}/?msg=${JSON.stringify(resCheck.msg)}&skip=${resCheck.data2 === true ? 1 : 0}&redirect_uri=${pwdRemindRedirectUri}`);
                            updateSkipPasswordCheck(false);
                            updatePasswordCheckMsg(resCheck.msg);
                            if (resCheck.data2 === true) {
                              updateShipChangePassword(true);
                            }
                          } else if (resCheck.msg !== undefined && resCheck.msg !== "") {
                            Setting.getResponseMessage(resCheck.msg);
                          } else {
                            Setting.goToLink(
                              loginRedirectUri
                            );
                          }
                        });
                    } else {
                      Setting.showMessage(
                        "error",
                        Setting.getResponseMessage(res.msg)
                      );
                    }
                  });
                }
                // Util.showMessage("success", `Authorization code: ${res.data}`);
              } else if (responseType === "token" || responseType === "id_token") {
                const accessToken = res.data;
                Setting.goToLink(
                  `${oAuthParams.redirectUri}#${responseType}=${accessToken}?state=${oAuthParams.state}&token_type=bearer`
                );
              } else if (responseType === "saml") {
                const SAMLResponse = res.data;
                const redirectUri = res.data2;
                Setting.goToLink(
                  `${redirectUri}?SAMLResponse=${encodeURIComponent(SAMLResponse)}&RelayState=${
                    oAuthParams.relayState
                  }`
                );
              }
            } else {
              Util.showMessage(
                "error",
                Setting.getResponseMessage(res.msg)
              );
            }
          });
        }
      } else {
        Setting.showResponseMessage(resPubKey.msg);
      }
    });
  }

  onBindAccountFinish(formValues, updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck, captchaPass = true, user = undefined) {
    const application = this.getApplicationObj();
    const ths = this;

    const weChatOfficialItem = this.state.application.providers.find((providerItem) => providerItem.provider.type === "WeChatOfficial");
    if (!weChatOfficialItem) {
      Setting.showMessage("error", i18next.t("微信公众号身份源不存在，请联系管理员"));
      return;
    }

    const endpoint = authInfo[weChatOfficialItem.provider.type].endpoint;
    const scope = authInfo[weChatOfficialItem.provider.type].scope;
    const isShortState = false;

    if (this.state.isPasswordSignin && !captchaPass) {
      this.captchaRef.current.getCaptcha();
      return;
    }

    const values = Setting.deepCopy(formValues);
    AuthBackend.getPublicKey().then(resPubKey => {
      if (resPubKey.status === "ok") {
        // 密码加密
        const encrypt = new JSEncrypt();
        encrypt.setPublicKey(resPubKey.msg);
        values["password"] = encrypt.encrypt(values["password"]);
        if (values["password"] === false) {
          values["password"] = "";
        }

        // here we are supposed to judge whether casdoor is working as a oauth server or CAS server
        if (ths.state.type === "cas") {
          // cas
          const params = new URLSearchParams(window.location.search);
          const login_url = Util.decodeUrl(params.get("login_url"));
          const loginUrl = new URL(login_url);

          const casParams = Util.getCasParameters(loginUrl.search === "" ? undefined : loginUrl.search);
          values["type"] = ths.state.type;
          values["phonePrefix"] = this.getApplicationObj().organizationObj === null ? "" : this.getApplicationObj().organizationObj.phonePrefix;

          AuthBackend.loginCas(values, casParams).then((res) => {
            if (res.status === "ok") {
              let msg = i18next.t("login:Logged in successfully.");
              if (casParams.service === "") {
                // If service was not specified, CAS MUST display a message notifying the client that it has successfully initiated a single sign-on session.
                msg += i18next.t("login:Now you can visit apps protected.");
              }
              if (casParams.service !== "") {
                const st = res.data;
                try {
                  const newUrl = new URL(casParams.service);
                  newUrl.searchParams.append("ticket", st);
                  Util.showMessage("success", msg);
                  // window.location.href = newUrl.toString();
                  const backUrl = Util.encodeUrl(newUrl.toString());
                  const redirectUri = `${window.location.origin}/callback?back_url=${backUrl}`;
                  const state = Util.getStateFromQueryParamsForWechatOfficial(application.uid, weChatOfficialItem.provider.uid, "link", isShortState, true, backUrl);
                  window.location.href = `${endpoint}?appid=${weChatOfficialItem.provider.clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
                } catch (error) {
                  Setting.showMessage("error", error.message);
                }
              } else {
                Util.showMessage("success", msg);
              }
            } else {
              Util.showMessage(
                "error",
                Setting.getResponseMessage(res.msg)
              );
            }
          });
        } else {
          // oauth
          const _params = new URLSearchParams(window.location.search);
          const login_url = Util.decodeUrl(_params.get("login_url"));
          const _loginUrl = new URL(login_url);

          const oAuthParams = Util.getOAuthGetParameters(_loginUrl.search === "" ? undefined : _loginUrl.searchParams);
          if (
            oAuthParams !== null &&
						oAuthParams.responseType !== null &&
						oAuthParams.responseType !== ""
          ) {
            values["type"] = oAuthParams.responseType;
          } else {
            values["type"] = this.state.type;
          }

          values["phonePrefix"] = this.getApplicationObj().organizationObj === null ? "" : this.getApplicationObj().organizationObj.phonePrefix;

          if (oAuthParams !== null) {
            values["samlRequest"] = oAuthParams.samlRequest;
          }

          if (values["samlRequest"] !== null && values["samlRequest"] !== "" && values["samlRequest"] !== undefined) {
            values["type"] = "saml";
          }

          AuthBackend.login(values, oAuthParams).then((res) => {
            if (res.status === "ok") {

              const responseType = values["type"];
              if (responseType === "login") {
                Util.showMessage("success", i18next.t("login:Logged in successfully."));
                const loginRedirectUri = Setting.getFromLink();
                const backUrl = Util.encodeUrl(loginRedirectUri);
                const redirectUri = `${window.location.origin}/callback?back_url=${backUrl}`;
                const state = Util.getStateFromQueryParamsForWechatOfficial(application.uid, weChatOfficialItem.provider.uid, "link", isShortState, true, backUrl);
                window.location.href = `${endpoint}?appid=${weChatOfficialItem.provider.clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
              } else if (responseType === "code") {
                const code = res.data;
                const concatChar = oAuthParams?.redirectUri?.includes("?") ? "&" : "?";

                if (Setting.hasPromptPage(application)) {
                  AuthBackend.getAccount("").then((res) => {
                    let account = null;
                    if (res.status === "ok") {
                      account = res.data;
                      let loginRedirectUri = "";
                      if (Setting.isPromptAnswered(account, application)) {
                        loginRedirectUri = `${oAuthParams.redirectUri}${concatChar}code=${code}&state=${oAuthParams.state}`;
                      } else {
                        loginRedirectUri = `/prompt/${application.uid}?redirectUri=${oAuthParams.redirectUri}&code=${code}&state=${oAuthParams.state}`;
                      }

                      const backUrl = Util.encodeUrl(loginRedirectUri);
                      const redirectUri = `${window.location.origin}/callback?back_url=${backUrl}`;
                      const state = Util.getStateFromQueryParamsForWechatOfficial(application.uid, weChatOfficialItem.provider.uid, "link", isShortState, true, backUrl);
                      window.location.href = `${endpoint}?appid=${weChatOfficialItem.provider.clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
                    } else {
                      Setting.showMessage(
                        "error",
                        Setting.getResponseMessage(res.msg)
                      );
                    }
                  });
                } else {
                  const fromUrl = `${oAuthParams.redirectUri}${concatChar}code=${code}&state=${oAuthParams.state}`;
                  const backUrl = Util.encodeUrl(fromUrl);
                  const wechatRedirect = `${window.location.origin}/callback?back_url=${backUrl}`;
                  const wechatState = Util.getStateFromQueryParamsForWechatOfficial(application.uid, weChatOfficialItem.provider.uid, "link", isShortState, true, backUrl);
                  window.location.href = `${endpoint}?appid=${weChatOfficialItem.provider.clientId}&redirect_uri=${wechatRedirect}&response_type=code&scope=${scope}&state=${wechatState}#wechat_redirect`;
                }
                // Util.showMessage("success", `Authorization code: ${res.data}`);
              } else if (responseType === "token" || responseType === "id_token") {
                const accessToken = res.data;
                const loginRedirectUri = `${oAuthParams.redirectUri}#${responseType}=${accessToken}?state=${oAuthParams.state}&token_type=bearer`;
                const backUrl = Util.encodeUrl(loginRedirectUri);
                const redirectUri = `${window.location.origin}/callback?back_url=${backUrl}`;
                const state = Util.getStateFromQueryParamsForWechatOfficial(application.uid, weChatOfficialItem.provider.uid, "link", isShortState, true, backUrl);
                window.location.href = `${endpoint}?appid=${weChatOfficialItem.provider.clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;

                // Setting.goToLink(
                //   `${oAuthParams.redirectUri}#${responseType}=${accessToken}?state=${oAuthParams.state}&token_type=bearer`
                // );
              } else if (responseType === "saml") {
                const SAMLResponse = res.data;
                const redirect = res.data2;
                const loginRedirectUri = `${redirect}?SAMLResponse=${encodeURIComponent(SAMLResponse)}&RelayState=${oAuthParams.relayState}`;
                const backUrl = Util.encodeUrl(loginRedirectUri);
                const redirectUri = `${window.location.origin}/callback?back_url=${backUrl}`;
                const state = Util.getStateFromQueryParamsForWechatOfficial(application.uid, weChatOfficialItem.provider.uid, "link", isShortState, true, backUrl);
                window.location.href = `${endpoint}?appid=${weChatOfficialItem.provider.clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;

                // Setting.goToLink(
                //   `${redirectUri}?SAMLResponse=${encodeURIComponent(SAMLResponse)}&RelayState=${
                //     oAuthParams.relayState
                //   }`
                // );
              }
            } else {
              Util.showMessage(
                "error",
                Setting.getResponseMessage(res.msg)
              );
            }
          });
        }
      } else {
        Setting.showResponseMessage(resPubKey.msg);
      }
    });
  }

  rememberAuthInfo(obj) {
    if (this.state.rememberUsername) {
      window.localStorage.setItem("rememberUsername", true);
      Setting.setCookie("username", obj.username);
    } else {
      window.localStorage.removeItem("rememberUsername");
      Setting.removeCookie("username");
    }
    if (this.state.rememberPassword) {
      window.localStorage.setItem("rememberPassword", true);
      if (obj.password) {
        Setting.setCookie("u_a_p_w_d", obj.password);
      }
    } else {
      window.localStorage.removeItem("rememberPassword");
      Setting.removeCookie("u_a_p_w_d");
    }
  }

  getSigninButton(type) {
    const text = i18next.t("login:Sign in with {type}").replace("{type}", type);
    if (type === "GitHub") {
      return <GithubLoginButton text={text} align={"center"} />;
    } else if (type === "Google") {
      return <GoogleLoginButton text={text} align={"center"} />;
    } else if (type === "QQ") {
      return <QqLoginButton text={text} align={"center"} />;
    } else if (type === "Facebook") {
      return <FacebookLoginButton text={text} align={"center"} />;
    } else if (type === "Weibo") {
      return <WeiboLoginButton text={text} align={"center"} />;
    } else if (type === "Gitee") {
      return <GiteeLoginButton text={text} align={"center"} />;
    } else if (type === "WeChat") {
      return <WechatLoginButton text={text} align={"center"} />;
    } else if (type === "DingTalk") {
      return <DingTalkLoginButton text={text} align={"center"} />;
    } else if (type === "LinkedIn") {
      return <LinkedInLoginButton text={text} align={"center"} />;
    } else if (type === "WeCom") {
      return <WeComLoginButton text={text} align={"center"} />;
    } else if (type === "Lark") {
      return <LarkLoginButton text={text} align={"center"} />;
    } else if (type === "GitLab") {
      return <GitLabLoginButton text={text} align={"center"} />;
    } else if (type === "Adfs") {
      return <AdfsLoginButton text={text} align={"center"} />;
    } else if (type === "Casdoor") {
      return <CasdoorLoginButton text={text} align={"center"} />;
    } else if (type === "Baidu") {
      return <BaiduLoginButton text={text} align={"center"} />;
    } else if (type === "Alipay") {
      return <AlipayLoginButton text={text} align={"center"} />;
    } else if (type === "Infoflow") {
      return <InfoflowLoginButton text={text} align={"center"} />;
    } else if (type === "Apple") {
      return <AppleLoginButton text={text} align={"center"} />;
    } else if (type === "AzureAD") {
      return <AzureADLoginButton text={text} align={"center"} />;
    } else if (type === "Slack") {
      return <SlackLoginButton text={text} align={"center"} />;
    } else if (type === "Steam") {
      return <SteamLoginButton text={text} align={"center"} />;
    }

    return text;
  }

  getSamlUrl(provider) {
    const params = new URLSearchParams(this.props.location.search);
    const clientId = params.get("client_id");
    const application = params.get("state");
    const realRedirectUri = params.get("redirect_uri");
    const redirectUri = `${window.location.origin}/callback/saml`;
    const providerId = provider.uid;
    const relayState = `${clientId}&${application}&${providerId}&${realRedirectUri}&${redirectUri}`;
    AuthBackend.getSamlLogin(`${provider.owner}/${providerId}`, btoa(relayState)).then((res) => {
      if (res.data2 === "POST") {
        document.write(res.data);
      } else {
        window.location.href = res.data;
      }
    });
  }

  renderProviderLogo(provider, application, width, margin, size, aStyle) {
    if (size === "small") {
      if (provider.category === "OAuth") {
        return (
          <a style={aStyle} key={provider.displayName} href={Provider.getAuthUrl(application, provider, "signup")}>
            <img
              width={width}
              height={width}
              src={Setting.getProviderLogoURL(provider)}
              alt={provider.displayName}
              style={{margin: margin}}
            />
          </a>
        );
      } else if (provider.category === "SAML") {
        return (
          <a style={aStyle} key={provider.displayName} onClick={this.getSamlUrl.bind(this, provider)}>
            <img
              width={width}
              height={width}
              src={Setting.getProviderLogoURL(provider)}
              alt={provider.displayName}
              style={{margin: margin}}
            />
          </a>
        );
      }
    } else {
      return (
        <div key={provider.displayName} style={{marginBottom: "10px"}}>
          <a href={Provider.getAuthUrl(application, provider, "signup")}>
            {this.getSigninButton(provider.type)}
          </a>
        </div>
      );
    }
  }

  isProviderVisible(providerItem) {
    if (this.state.mode === "signup") {
      return Setting.isProviderVisibleForSignUp(providerItem);
    } else {
      return Setting.isProviderVisibleForSignIn(providerItem);
    }
  }

  renderForm(application, updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck) {
    if (this.state.msg !== null) {
      return Util.renderMessage(this.state.msg);
    }
    if (this.state.mode === "signup" && !application.enableSignUp) {
      return (
        <Result
          status="error"
          title="Sign Up Error"
          subTitle={"The application does not allow to sign up new account"}
          extra={[
            <Link
              onClick={() => {
                Setting.goToLogin(this, application);
              }}
              key="form"
            >
              <Button type="primary" key="signin">
                Sign In
              </Button>
            </Link>,
          ]}
        ></Result>
      );
    }

    if (application.enablePassword) {
      let usernameMsg = "",
        usernamePlaceholder = "";
      if (this.state.isPasswordSignin) {
        usernameMsg = i18next.t("login:Please input your username!");
        usernamePlaceholder = i18next.t("login:username");
      } else if (this.state.isPhoneSignin) {
        usernameMsg = i18next.t("login:Please input your phone!");
        usernamePlaceholder = i18next.t("login:Please input phone");
      } else if (this.state.isEmailSignin) {
        usernameMsg = i18next.t("login:Please input your email!");
        usernamePlaceholder = i18next.t("login:Please input email");
      }

      return (
        <Form
          name="normal_login"
          initialValues={{
            organization: application.organization,
            application: application.uid,
            autoSignin: true,
            username: this.state.username,
            password: this.state.cookiPassword,
          }}
          onFinish={(values) => {
            if (this.state.isPasswordSignin) {
              this.onFinish(values, updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck, false);
              return;
            }
            this.onFinish(values, updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck);
          }}
          style={this.isMobile() ? {} : {width: isSmallScreen ? "100%" : 372}}
          size="large"
          labelCol={{span: 20, offset: 32}}
          ref={this.formRef}
        >
          <Form.Item
            style={{height: 0, visibility: "hidden", display: "none"}}
            name="application"
            rules={[
              {
                required: true,
                message: i18next.t("login:Please input your application!"),
              },
            ]}
          ></Form.Item>
          <Form.Item
            style={{height: 0, visibility: "hidden", display: "none"}}
            name="organization"
            rules={[
              {
                required: true,
                message: i18next.t("login:Please input your organization!"),
              },
            ]}
          ></Form.Item>
          <Form.Item
            name="username"
            style={this.isMobile() ?
              {height: 44, fontSize: 14, marginBottom: 18}
              :
              {marginBottom: 18}}
            rules={[
              {
                required: true,
                message: usernameMsg,
              },
              {
                validator: (_, value) => {
                  if (value === undefined || value === "") {
                    return Promise.resolve();
                  }

                  if (value.length > 50) {
                    return Promise.reject(
                      i18next.t("general:Limited number of characters is {number}").replace("{number}", 50)
                    );
                  }
                  if (this.state.isPhoneSignin && !Setting.isValidPhone(this.state.username)) {
                    this.setState({validEmailOrPhone: false});
                    return Promise.reject(
                      i18next.t("login:The input is not valid Phone!")
                    );
                  }
                  if (this.state.isEmailSignin && !Setting.isValidEmail(this.state.username)) {
                    this.setState({validEmailOrPhone: false});
                    return Promise.reject(
                      i18next.t("login:The input is not valid Email!")
                    );
                  }
                  if (this.state.isPhoneSignin && Setting.isValidPhone(this.state.username)) {
                    this.setState({validPhone: true});
                  }
                  if (this.state.isEmailSignin && Setting.isValidEmail(this.state.username)) {
                    this.setState({validEmail: true});
                  }
                  this.setState({validEmailOrPhone: true});
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input
              prefix={<UserOutlined className="site-form-item-icon" />}
              placeholder={usernamePlaceholder}
              disabled={!application.enablePassword}
              onChange={(e) => {
                this.setState({
                  username: e.target.value,
                });
              }}
            />
          </Form.Item>
          {!this.state.isPasswordSignin ? (
            <Form.Item
              name="code"
              style={this.isMobile() ?
                {height: 44, marginBottom: 18}
                :
                {marginBottom: 18}}
              rules={[
                {required: true, message: i18next.t("login:Please input your code!")},
                {
                  validator: (_, value) => {
                    if (value !== undefined && value.length > 6) {
                      return Promise.reject(
                        i18next.t("general:Limited number of characters is {number}").replace("{number}", 6)
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <CountDownInput
                disabled={this.state.username?.length === 0 || !this.state.validEmailOrPhone}
                onButtonClickArgs={[
                  this.state.username,
                  this.state.validEmail ? "email" : "phone",
                  Setting.getApplicationName(application),
                ]}
                application={application}
                from="login"
              />
            </Form.Item>
          ) : (
            <Form.Item
              name="password"
              style={this.isMobile() ?
                {height: 44, marginBottom: 18}
                :
                {marginBottom: 18}}
              getValueFromEvent = {
                (event) => {
                  return event.target.value.replace(/[\u4E00-\u9FA5]/g, "");
                }
              }
              rules={[{required: true, message: i18next.t("login:Please input your password!")}]}
            >
              <Input.Password
                prefix={<LockOutlined className="site-form-item-icon" />}
                type="password"
                placeholder={i18next.t("login:Password")}
                disabled={!application.enablePassword}
              />
            </Form.Item>
          )}
          <Form.Item style={this.isMobile() ?
            {marginBottom: 8}
            :
            {marginBottom: 18}}>
            <Button
              type="primary"
              htmlType="submit"
              className="submit-button"
              style={this.isMobile() ?
                {height: 44, fontSize: 17, width: "100%", backgroundColor: "#B5122A", borderRadius: 5}
                :
                {width: "100%", height: isSmallScreen ? 36 : 48, fontSize: isSmallScreen ? 16 : 24,
                  background: "#B5122A"}}
              disabled={!application.enablePassword}
            >
              {i18next.t("login:Sign In")}
            </Button>
          </Form.Item>
          <Form.Item
            style={this.isMobile() ?
              {height: 40, fontSize: 13}
              :
              {marginBottom: isSmallScreen ? 20 : 41, marginTop: -16}}
          >
            {this.isMobile() || !application.enableAutoSignin ? null : <Form.Item name="autoSignin" valuePropName="checked" noStyle>
              <Checkbox style={{float: "left", fontSize: isSmallScreen ? 14 : 16, color: "#fff"}} disabled={!application.enablePassword}>
                {i18next.t("login:Auto sign in")}
              </Checkbox>
            </Form.Item>
            }
            {
              !application.organizationObj?.needActivation ? null :
                <a
                  style={this.isMobile() ?
                    {float: "left", fontSize: 13}
                    :
                    {float: "left", fontSize: isSmallScreen ? 14 : 16}}
                  onClick={() => {
                    const encode = Util.encodeUrl(window.location.href);
                    Setting.goToActivate(this, application, `?login_url=${encode}`);
                  }}
                >
                  {i18next.t("login:Account Activate")}
                </a>
            }
            <div style={{float: "right", display: "flex", justifyContent: "flex-end"}}>
              <Checkbox style={{color: "#fff"}} checked={this.state.rememberUsername} onChange={() => {
                this.setState({
                  rememberUsername: !this.state.rememberUsername,
                });
              }}>记住账号</Checkbox>
              <Checkbox style={{color: "#fff"}} checked={this.state.rememberPassword} onChange={() => {
                this.setState({
                  rememberPassword: !this.state.rememberPassword,
                });
              }}>记住密码</Checkbox>
              <a
                style={this.isMobile() ?
                  {marginLeft: "8px", fontSize: 13}
                  :
                  {marginLeft: "8px", fontSize: isSmallScreen ? 14 : 16}}
                onClick={() => {
                  const zip = Util.encodeUrl(window.location.href);
                  Setting.goToForget(this, application, `?login_url=${zip}`);
                }}
              >
                {i18next.t("login:Forgot password?")}
              </a>
            </div>
          </Form.Item>
        </Form>
      );
    } else {
      return (
        <div style={{marginTop: "20px"}}>
          <div style={{fontSize: 16, textAlign: "left"}}>
            {i18next.t("login:To access")}&nbsp;
            <a target="_blank" rel="noreferrer" href={application.homepageUrl}>
              <span style={{fontWeight: "bold"}}>{application.displayName}</span>
            </a>
            :
          </div>
          <br />
          {application.providers
            .filter((providerItem) => this.isProviderVisible(providerItem))
            .map((providerItem) => {
              return this.renderProviderLogo(providerItem.provider, application, 40, 10, "big");
            })}
          {!application.enableSignUp ? null : (
            <div>
              <br />
              {this.renderFooter(application)}
            </div>
          )}
        </div>
      );
    }
  }

  renderBindForm(application, updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck) {
    return (
      <Form
        name="normal_login"
        initialValues={{
          organization: application.organization,
          application: application.uid,
          autoSignin: true,
        }}
        onFinish={(values) => {
          if (this.state.isPasswordSignin) {
            this.onBindAccountFinish(values, updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck, false);
            return;
          }
          this.onBindAccountFinish(values, updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck);
        }}
        style={this.isMobile() ? {} : {width: isSmallScreen ? "100%" : 372}}
        size="large"
        labelCol={{span: 20, offset: 32}}
        ref={this.formRef}
      >
        <Form.Item
          style={{height: 0, visibility: "hidden", display: "none"}}
          name="application"
          rules={[
            {
              required: true,
              message: i18next.t("login:Please input your application!"),
            },
          ]}
        ></Form.Item>
        <Form.Item
          style={{height: 0, visibility: "hidden", display: "none"}}
          name="organization"
          rules={[
            {
              required: true,
              message: i18next.t("login:Please input your organization!"),
            },
          ]}
        ></Form.Item>
        <Form.Item
          name="username"
          style={this.isMobile() ?
            {height: 44, fontSize: 14, marginBottom: 18}
            :
            {marginBottom: 18}}
          rules={[
            {
              required: true,
              message: i18next.t("login:Please input your username!"),
            },
            {
              validator: (_, value) => {
                if (value === undefined || value === "") {
                  return Promise.resolve();
                }

                if (value.length > 50) {
                  return Promise.reject(
                    i18next.t("general:Limited number of characters is {number}").replace("{number}", 50)
                  );
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input
            prefix={<UserOutlined className="site-form-item-icon" />}
            placeholder={i18next.t("login:username")}
            disabled={!application.enablePassword}
            onChange={(e) => {
              this.setState({
                username: e.target.value,
              });
            }}
          />
        </Form.Item>
        <Form.Item
          name="password"
          style={this.isMobile() ?
            {height: 44, marginBottom: 18}
            :
            {marginBottom: 18}}
          getValueFromEvent = {
            (event) => {
              return event.target.value.replace(/[\u4E00-\u9FA5]/g, "");
            }
          }
          rules={[{required: true, message: i18next.t("login:Please input your password!")}]}
        >
          <Input.Password
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder={i18next.t("login:Password")}
            disabled={!application.enablePassword}
          />
        </Form.Item>
        <Form.Item style={this.isMobile() ?
          {marginBottom: 8}
          :
          {marginBottom: 18}}>
          <Button
            type="primary"
            htmlType="submit"
            className="submit-button"
            style={this.isMobile() ?
              {height: 44, fontSize: 17, width: "100%", backgroundColor: "#B5122A", borderRadius: 5}
              :
              {width: "100%", height: isSmallScreen ? 36 : 48, fontSize: isSmallScreen ? 16 : 24,
                background: "#B5122A"}}
            disabled={!application.enablePassword}
          >
            {i18next.t("login:Sign In")}
          </Button>
        </Form.Item>
        <Form.Item
          style={this.isMobile() ?
            {height: 40, fontSize: 13}
            :
            {marginBottom: isSmallScreen ? 20 : 41, marginTop: -16}}
        >
          {
            !application.organizationObj?.needActivation ? null :
              <a
                style={this.isMobile() ?
                  {float: "left", fontSize: 13}
                  :
                  {float: "left", fontSize: isSmallScreen ? 14 : 16}}
                onClick={() => {
                  const encode = Util.encodeUrl(window.location.href);
                  Setting.goToActivate(this, application, `?login_url=${encode}`);
                }}
              >
                {i18next.t("login:Account Activate")}
              </a>
          }
          <a
            style={this.isMobile() ?
              {float: "right", fontSize: 13}
              :
              {float: "right", fontSize: isSmallScreen ? 14 : 16}}
            onClick={() => {
              const zip = Util.encodeUrl(window.location.href);
              Setting.goToForget(this, application, `?login_url=${zip}`);
            }}
          >
            {i18next.t("login:Forgot password?")}
          </a>
        </Form.Item>
      </Form>
    );
  }

  renderFormFooter(application) {
    const iconButtonStyle = {
      width: 40,
      height: 40,
      borderRadius: 8,
      padding: "2px 0 0 0",
      borderColor: "rgba(0, 0, 0, 0.08)",
      marginRight: 10,
    };
    const colorBlue = "#08B14C";

    return (
      <div style={{display: "flex", flexDirection: "row",
        alignItems: "center", marginTop: isSmallScreen ? 12 : 20}}>
        {
          !application.enablePassword ? null :
            <Button className={`login-icon-hover-green ${this.state.isPasswordSignin ? "login-icon-selected-green" : ""}`} style={iconButtonStyle}
              icon={<IconFont.LoginPwdIcon style={{color: colorBlue, fontSize: 22}} />}
              onClick={() => {
                this.setState({
                  isPasswordSignin: true,
                  isPhoneSignin: false,
                  isEmailSignin: false,
                });
                this.formRef.current.validateFields();
              }}
            >
            </Button>
        }
        {
          Setting.isMobile() ? null
            :
            application.providers
              .filter((providerItem) => this.isProviderVisible(providerItem))
              .map((providerItem) => {
                return (<div className="login-hover-blue" style={{border: "1px solid", display: "flex", justifyContent: "center", alignItems: "center", ...iconButtonStyle}} key={providerItem.uid}>
                  {this.renderProviderLogo(providerItem.provider, application, 22, "0, 0, 0, 0", "small", {width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center"})}
                </div>);
              })
        }
      </div>
    );
  }

  renderFooter(application) {
    if (this.state.mode === "signup") {
      return (
        <div style={{float: "right"}}>
          {i18next.t("signup:Have account?")}&nbsp;
          <Link
            onClick={() => {
              Setting.goToLogin(this, application);
            }}
          >
            {i18next.t("signup:sign in now")}
          </Link>
        </div>
      );
    } else {
      return (
        <React.Fragment>
          <span style={{float: "left"}}>
            {!application.enableCodeSignin ? null : (
              <a
                onClick={() => {
                  this.setState({
                    isCodeSignin: !this.state.isCodeSignin,
                  });
                }}
              >
                {this.state.isCodeSignin
                  ? i18next.t("login:Sign in with password")
                  : i18next.t("login:Sign in with code")}
              </a>
            )}
          </span>
          <span style={{float: "right"}}>
            {i18next.t("login:No account?")}&nbsp;
            <a
              onClick={() => {
                sessionStorage.setItem("loginURL", window.location.href);
                Setting.goToSignup(this, application);
              }}
            >
              {i18next.t("login:sign up now")}
            </a>
          </span>
        </React.Fragment>
      );
    }
  }

  renderSignedInBox(updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck) {
    if (this.props.account === undefined || this.props.account === null) {
      if (this.state.pageLoading) {
        this.setState({
          pageLoading: false,
        });
      }
      return null;
    }
    const application = this.getApplicationObj();

    if (this.props.account.owner !== application.organization) {
      if (this.state.pageLoading) {
        this.setState({
          pageLoading: false,
        });
      }
      return null;
    }

    const params = new URLSearchParams(this.props.location.search);
    const silentSignin = params.get("silentSignin");
    if (silentSignin !== null) {
      if (window !== window.parent) {
        const message = {tag: "Casdoor", type: "SilentSignin", data: "signing-in"};
        window.parent.postMessage(message, "*");
      }

      // let values = {};
      // values["application"] = this.state.application.uid;
      // this.onFinish(values);
    }

    const values = {};
    values["application"] = this.state.application.uid;
    // values["username"] = this.props.account.name;
    this.onFinish(values, updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck, true, this.props.account.name);

    // return (
    //   <div>
    //     <div style={{ fontSize: 16, textAlign: "left", marginTop: "24px" }}>
    //       {i18next.t("login:Continue with")}&nbsp;:
    //     </div>
    //     <br />
    // <SelfLoginButton
    //   account={this.props.account}
    //   onClick={() => {
    //     let values = {};
    //     values["application"] = this.state.application.uid;
    //     this.onFinish(values);
    //   }}
    // />
    //     <br />
    //     <br />
    //     <div style={{ fontSize: 16, textAlign: "left" }}>
    //       {i18next.t("login:Or sign in with another account")}&nbsp;:
    //     </div>
    //   </div>
    // );

    return (
      // <div style={{display:"flex", flexDirection:"row", alignItems:"center", marginBottom: 19}}>
      //   <div style={{ fontSize: isSmallScreen ? 16 : 20, textAlign: "left", margin: "0", color:"#434343"}}>
      //     {i18next.t("login:Continue with")}&nbsp;:
      //   </div>
      //   <Button style={{fontSize: isSmallScreen ? 16 : 20, padding: 0, height: isSmallScreen ? 36 : 48}}
      //     type="link"
      //     onClick={() => {
      //       let values = {};
      //       values["application"] = this.state.application.uid;
      //       this.onFinish(values);
      //     }}>
      //      {/* {`${this.props.account.name} (${this.props.account.displayName})`} */}
      //    </Button>
      // </div>
      null
    );
  }

  renderSignFormLogo() {
    const styleDisplayname = {
      color: "#fff",
      margin: "0 0 0 26px",
      fontSize: isSmallScreen ? 20 : 24,
    };
    const logo = {
      width: 210,
      height: 54,
    };
    const styleBox = {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
    };

    return (
      <div style={styleBox}>
        <img
          src={require("../../assets/images/logo.png")}
          alt={i18next.t("login:Platform login")}
          style={logo}
        />
        <p style={styleDisplayname}>统一身份认证</p>
      </div>
    );
  }

  renderSigninTips() {
    const styleTip = {
        color: "#4d4d4d",
        fontSize: 14,
        marginBottom: 8,
      },
      styleSigninTip = {
        fontSize: 12,
        color: "#767676",
        margin: 0,
      },
      browserDiv = {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginTop: 10,
      },
      browserIco = {
        marginLeft: isSmallScreen ? 14 : 27,
        width: 24,
        height: 24,
      },
      browserRecom = {
        margin: 0,
        fontSize: 14,
        color: "#4d4d4d",
      },
      browserName = {
        margin: "0 0 0 5px",
        fontSize: 12,
        color: "#767676",
      };
    return (
      <React.Fragment>
        <p style={styleTip}>{i18next.t("login:Sign in tips")}：</p>
        <p style={styleSigninTip}>{i18next.t("login:Sign in tip1")}</p>
        <p style={styleSigninTip}>{i18next.t("login:Sign in tip2")}</p>
        <div style={browserDiv}>
          <p style={browserRecom}>{i18next.t("login:Browser recommended")}：</p>
          <img style={browserIco} src={require("../../assets/images/chrome.png")} alt={i18next.t("login:Chrome")} />
          <p style={browserName}>{i18next.t("login:Chrome")}</p>
          <img style={browserIco} src={require("../../assets/images/firefox.png")} alt={i18next.t("login:Firefox")} />
          <p style={browserName}>{i18next.t("login:Firefox")}</p>
          <img style={browserIco} src={require("../../assets/images/360.png")} alt={i18next.t("login:360")} />
          <p style={browserName}>{i18next.t("login:360")}</p>
        </div>
      </React.Fragment>
    );
  }

  renderLogo(application) {
    // 禁止点击
    application.homepageUrl = null;
    if (application === null) {
      return null;
    }

    const styleDisplayname = {
        color: "#F16037",
        marginLeft: 21,
        fontSize: isSmallScreen ? 20 : 24,
      },
      styleLogo = {
        width: "auto",
        height: isSmallScreen ? 49 : 98,
        // marginTop: 26,
        // marginLeft: 26,
      };
    // console.log(application)
    if (application.homepageUrl !== "") {
      return (
        <a
          target="_blank"
          rel="noreferrer"
          href={application.homepageUrl}
          className="logo-box">
          {
            application.systemLogo === "" ?
              <img
                src={application.logo === "" ? require("../../assets/images/default_icon_red.png") : application.logo}
                alt={application.displayName}
                style={styleLogo}
              />
              :
              <Col>
                <li className="icon-container" style={{width: isSmallScreen ? 36 : 48, height: isSmallScreen ? 36 : 48}}
                >
                  <span className={["app-icon", `${iconfont.font_family} ${iconfont.css_prefix_text}${application.systemLogo}`].join(" ")}
                    style={{width: isSmallScreen ? 36 : 48, height: isSmallScreen ? 36 : 48, fontSize: isSmallScreen ? 36 : 48, color: "#fff"}}></span>
                </li>
              </Col>
          }
        </a>
      );
    } else {
      return (
        <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
          {
            application.systemLogo === "" ?
              <img
                src={application.logo === "" ? require("../../assets/images/default_icon_red.png") : application.logo}
                alt={application.displayName}
                style={styleLogo}
              />
              :
              <Col>
                {
                  <li className="icon-container" style={{width: 48, height: 48}}
                  >
                    <span className={["app-icon", application.sysLogoBg].join(" ")} style={{width: 40, height: 40, fontSize: isSmallScreen ? 20 : 32}}></span>
                  </li>
                }
              </Col>
          }
          <p style={styleDisplayname}>{application.displayName}</p>
        </div>
      );
    }
  }

  // 加载微信二维码
  loadWeChatQRCode(wechatConfig, applicationRes) {
    if (!wechatConfig || !applicationRes) {
      return;
    }
    const isShortState = navigator.userAgent.includes("MicroMessenger");
    const encode = Util.encodeUrl(window.location.href);
    const state = Util.getStateFromQueryParams(applicationRes.uid, wechatConfig.uid, "signup", isShortState);
    const redirectUri = `${window.location.origin}/login?login_url=${encode}`;
    const obj = new window.WxLogin({
      self_redirect: false,
      id: "wechat_login",
      appid: wechatConfig.provider.clientId,
      scope: navigator.userAgent.includes("MicroMessenger") ? WeChat.mpScope : WeChat.scope,
      state: state,
      redirect_uri: encodeURI(redirectUri),
      href: "data:text/css;base64,LndldWlfbXNnX3RpdGxlIHsKCWNvbG9yOiAjZmZmOwp9Cgoud2V1aV9tc2cgLndldWlfbXNnX3RpdGxlIHsKCWNvbG9yOiAjZmZmOwp9CgouaW1wb3dlckJveCAudGl0bGUgewoJZGlzcGxheTogbm9uZTsKfQoKLmltcG93ZXJCb3ggLnFyY29kZSB7Cgl3aWR0aDogMjQwcHg7CgltYXJnaW4tdG9wOiAwOwp9CgouaW1wb3dlckJveCAuaW5mbyB7CglkaXNwbGF5OiBub25lOwp9CgoucWxvZ2luX3VzZXJfbmlja25hbWUgewoJY29sb3I6ICNmZmY7Cn0KCi5xbG9naW5fbXNnIHsKCWNvbG9yOiAjZmZmOwp9Cgoud2ViX3FyY29kZV9zd2l0Y2hfd3JwIC53ZXVpLWxpbmsgewoJY29sb3I6ICNmZmY7Cn0=",
      lang: "zh",
    });
    // eslint-disable-next-line no-console
    console.log("6666", obj);
  }

  handleWxLogin = () => {
    try {
      const weChatOfficialItem = this.state.application.providers.find((providerItem) => providerItem.provider.type === "WeChatOfficial");
      if (!weChatOfficialItem) {
        Setting.showMessage("error", i18next.t("微信公众号身份源不存在，请联系管理员"));
        return;
      }

      const endpoint = authInfo[weChatOfficialItem.provider.type].endpoint;
      const isShortState = false;
      const state = Util.getStateFromQueryParams(this.state.application.uid, weChatOfficialItem.uid, "signup", isShortState);
      const encode = Util.encodeUrl(window.location.href);
      const redirectUri = `${window.location.origin}/login?login_url=${encode}`;
      window.location.href = `${endpoint}?appid=${weChatOfficialItem.provider.clientId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=${state}#wechat_redirect`;
    } catch (err) {
      Setting.showMessage("error", err.message);
    }
  };

  handleCaptchaConfirm = (updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck) => {
    if (this.state.wechatOfficialBind) {
      this.onBindAccountFinish(this.formRef.current.getFieldsValue(true), updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck, true);
      return;
    }
    this.onFinish(this.formRef.current.getFieldsValue(true), updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck, true);
  };

  render() {
    const application = this.getApplicationObj();
    if (application === null) {
      return Util.renderMessageLarge(this, Setting.getResponseMessage(this.state.msg), () => {
        window.history.back();
      });
    }
    if (this.state.casParamException) {
      return Util.renderMessageLarge(this, i18next.t("cas参数异常"), () => {
        window.history.back();
      });
    }

    if (application.signinHtml !== "") {
      return <div dangerouslySetInnerHTML={{__html: application.signinHtml}} />;
    }

    const visibleOAuthProviderItems = application.providers.filter((providerItem) =>
      this.isProviderVisible(providerItem)
    );
    if (
      this.props.application === undefined &&
      !application.enablePassword &&
      visibleOAuthProviderItems.length === 1
    ) {
      Setting.goToLink(
        Provider.getAuthUrl(application, visibleOAuthProviderItems[0].provider, "signup")
      );
      return (
        <div style={{textAlign: "center"}}>
          <Spin size="large" tip={i18next.t("login:Signing in...")} style={{paddingTop: "40px"}} />
        </div>
      );
    }

    /* 样式start */
    const antCol24Div = {
        display: "flex",
        borderRadius: 10,
        boxShadow: "0px 4px 40px 0px rgba(45, 98, 147, 0.1)",
      },
      mainLeft = {
        padding: isSmallScreen ? "28px 36px 24px 36px" : "45px 50px 28px 50px",
      },
      antCol24Head = {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-end",
        justifyContent: "space-between",
        height: "100%",
        backgroundSize: "cover",
      },
      styleToggleLanguage = {
        fontSize: 13,
        // backgroundColor: "rgba(252, 252, 252, 0.7)",
        // color: "#2078FF",
        padding: "6px 10px",
        borderRadius: 3,
      };

    /* 移动端适配 */
    const antCol24Mobile = {
        width: "100%",
        height: "100%",
        position: "relative",
        overflow: "auto",
      },
      antCol24DivMobile = {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        minHeight: 390,
        width: "86%",
        margin: "0 auto",
        boxSizing: "border-box",
        padding: "24px 28px 14px",
        backgroundColor: "rgba(0, 0, 0, 0.65)",
        borderRadius: 8,
        boxShadow: "4px 4px 24px 0px rgba(54, 85, 141, 0.1)",
        position: "relative",
        marginBottom: "20px",
      },
      styleToggleLanguageMobile = {
        fontSize: 13,
        // backgroundColor: "rgba(252, 252, 252, 0.7)",
        // color: "#2078FF",
        padding: "0 6px",
        borderRadius: 3,
      };
    const menuBtn = <div style={styleToggleLanguage}>{i18next.t("language:Selected language")}</div>;
    const menuBtnMobile = <div style={styleToggleLanguageMobile}>{i18next.t("language:Selected language")}</div>;
    /* 样式end */
    if (this.state.pageLoading) {
      return <div style={{width: "100vw", height: "100vh", display: "flex", justifyContent: "center", alignItems: "center"}}>
        <Spin />
        {this.renderSignedInBox()}
      </div>;
    }

    return (
      <GlobalContext.Consumer>
        {
          ({updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck}) => (
            <>
              <>
                {this.isMobile() ?
                  Setting.getENVIR() === "wxh5" && !this.state.wechatOfficialBind && !this.state.wechatOfficialSms ?
                    <div className="wechat-official-page">
                      <div className="mobile-head">
                        {this.renderLogo(application)}
                        {/* <div className="lang-box">
                            <img className="lang-icon-global" src={require("../../assets/images/global.png")} alt="Casdoor" />
                            <SelectLanguageBox menuBtn={menuBtnMobile}></SelectLanguageBox>
                            <img className="lang-icon-arrow" src={require("../../assets/images/arrow-bottom.png")} alt="Casdoor" />
                          </div> */}
                      </div>
                      <div className="login-center">
                        <img className="login-center-bg" src={require("../../assets/images/login-wechat-bg.png")} alt="Casdoor" />
                        <div className="center-tip1">Hi，请登录~</div>
                        {/* <div className="center-tip2">授权登录之后可以获得更好得体验哦</div> */}
                      </div>
                      {this.renderSignedInBox(updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck)}
                      <Button className="wechat-official-submit" onClick={this.handleWxLogin}>微信公众号一键授权登录</Button>
                      <Button className="wechat-official-activate" onClick={() => {
                        const encode = Util.encodeUrl(window.location.href);
                        Setting.goToActivate(this, application, `?login_url=${encode}`);
                      }}>账号激活</Button>
                      <Button className="wechat-official-sms" onClick={() => {
                        this.setState({
                          wechatOfficialSms: true,
                        });
                      }}>短信登录</Button>
                    </div>
                    :
                    <div className="mobile-login-page">
                      <Row style={{
                        height: "100vh", width: "100vw",
                      }}>
                        <Col span={24} style={antCol24Mobile}>
                          <div className="mobile-head">
                            {this.renderLogo(application)}
                            <div className="lang-box">
                              <img className="lang-icon-global" src={require("../../assets/images/global.png")} alt="Casdoor" />
                              <SelectLanguageBox menuBtn={menuBtnMobile}></SelectLanguageBox>
                              <img className="lang-icon-arrow" src={require("../../assets/images/arrow-bottom.png")} alt="Casdoor" />
                            </div>
                          </div>
                          <div className="page-name">统一身份认证平台</div>
                          {
                            !this.state.attentionMobileShow ? (
                              <div style={antCol24DivMobile}>
                                {this.props?.isPreview ? null
                                  :
                                  Setting.renderHelmet(application)}
                                <div style={{width: "100%"}}>
                                  {
                                    this.state.wechatOfficialBind ?
                                      <p className="login-label">{"登录账号绑定"}</p>
                                      :
                                      <div className="tabs-signin-way" style={{marginBottom: 15}}>
                                        <Tabs activeKey={this.state.signinWay} onChange={(activeKey) => {
                                          this.setState({
                                            signinWay: activeKey,
                                          });

                                          if (activeKey === "account") {
                                            this.setState({
                                              isPasswordSignin: true,
                                              isPhoneSignin: false,
                                              isEmailSignin: false,
                                            });
                                          } else {
                                            this.setState({
                                              isPasswordSignin: false,
                                              isPhoneSignin: true,
                                              isEmailSignin: false,
                                            });
                                          }
                                        }}>
                                          <Tabs.TabPane tab="账号登录" key="account">
                                          </Tabs.TabPane>
                                          <Tabs.TabPane tab="短信验证码" key="phone">
                                          </Tabs.TabPane>
                                        </Tabs>
                                      </div>
                                  }
                                </div>
                                {this.renderSignedInBox(updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck)}
                                {!this.state.wechatOfficialBind ?
                                  this.renderForm(application, updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck) :
                                  this.renderBindForm(application, updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck)}
                                {/* <div className="other-label">其他登录方式</div>
                                <div className="weixin-btn">
                                  <img src={require("../../assets/images/weixin.png")} alt={i18next.t("login:WeChat")} />
                                </div> */}
                                <div className="attention-btn-wrap">
                                  <span>点击阅读</span>
                                  <span className="attention-btn" onClick={() => {
                                    this.setState({
                                      attentionMobileShow: true,
                                    });
                                  }}>《注意事项》</span>
                                </div>
                              </div>
                            ) :
                              (<div className="attention-box-mobile">
                                <div className="attention-content">
                                  <div className="title">账号说明</div>
                                  <p>教职工的账号为工号，学生的账号为学号。初次登录请先激活账号。</p>
                                  <div className="title">忘记密码</div>
                                  <p>用户可点击“忘记密码”，通过密保问题或邮箱以自助方式找回密码。</p>
                                  <div className="title">扫码登录</div>
                                  <p>如果已经关注了学校微信公众号则可以通过手机微信扫描二维码登录系统。</p>
                                </div>
                                <div className="attention-back"
                                  onClick={() => {
                                    this.setState({
                                      attentionMobileShow: false,
                                    });
                                  }}>
                                  <img className="attention-back-icon" src={require("../../assets/images/icon-back.png")} alt="返回" />
                                    返回登录
                                </div>
                              </div>)
                          }
                        </Col>
                      </Row>
                    </div>
                  :
                  <React.Fragment>
                    <div className="login-page">
                      <Row style={{height: isSmallScreen ? 80 : 138}}>
                        <Col span={24} style={antCol24Head}>
                          {this.renderLogo(application)}
                        </Col>
                      </Row>
                      <Row style={{height: isSmallScreen ? "calc(100vh - 80px)" : "calc(100vh - 138px)", display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <div className="main-wrap">
                          <div className="lang-box">
                            <img className="lang-icon-global" src={require("../../assets/images/global.png")} alt="Casdoor" />
                            <SelectLanguageBox menuBtn={menuBtn}></SelectLanguageBox>
                            <img className="lang-icon-arrow" src={require("../../assets/images/arrow-bottom.png")} alt="Casdoor" />
                          </div>
                          <div style={antCol24Div}>
                            <div className="main-left" style={mainLeft}>
                              {this.props?.isPreview ? null
                                :
                                Setting.renderHelmet(application)}
                              <CustomGithubCorner />
                              <div style={{marginBottom: isSmallScreen ? 20 : 38, width: "100%"}}>
                                {this.renderSignFormLogo()}
                              </div>
                              {!this.state.attentionShow ? (
                                <div>
                                  <div className="tabs-signin-way" style={{marginBottom: 15}}>
                                    <Tabs activeKey={this.state.signinWay} onChange={(activeKey) => {
                                      this.setState({
                                        signinWay: activeKey,
                                      });

                                      if (activeKey === "account") {
                                        this.setState({
                                          isPasswordSignin: true,
                                          isPhoneSignin: false,
                                          isEmailSignin: false,
                                        });
                                      } else {
                                        this.setState({
                                          isPasswordSignin: false,
                                          isPhoneSignin: true,
                                          isEmailSignin: false,
                                        });
                                      }
                                    }}>
                                      <Tabs.TabPane tab="账号登录" key="account">
                                      </Tabs.TabPane>
                                      <Tabs.TabPane tab="短信验证码" key="phone">
                                      </Tabs.TabPane>
                                    </Tabs>
                                  </div>
                                  {this.renderForm(application, updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck)}
                                  {this.renderSignedInBox()}
                                  <div className="attention-btn-wrap">
                                    <span>点击阅读</span>
                                    <span className="attention-btn"
                                      onClick={() => {
                                        this.setState({
                                          attentionShow: true,
                                        });
                                      }}>《注意事项》</span>
                                  </div>
                                </div>) : (
                                <div className="attention-box">
                                  <div className="attention-content">
                                    <div className="title">账号说明</div>
                                    <p>教职工的账号为工号，学生的账号为学号。初次登录请先激活账号。</p>
                                    <div className="title">忘记密码</div>
                                    <p>用户可点击“忘记密码”，通过密保问题或邮箱以自助方式找回密码。</p>
                                    <div className="title">扫码登录</div>
                                    <p>如果已经关注了学校微信公众号则可以通过手机微信扫描二维码登录系统。</p>
                                  </div>
                                  <div className="attention-back"
                                    onClick={() => {
                                      this.setState({
                                        attentionShow: false,
                                      });
                                    }}>
                                    <img className="attention-back-icon" src={require("../../assets/images/icon-back.png")} alt="返回" />
                                    返回登录
                                  </div>
                                </div>
                              )}
                            </div>
                            {/* <div className="main-right">
                              <div id="wechat_login" className="qr-code">
                                {!this.state.wechatProvider && <div className="no-wechat-msg">微信身份源未配置</div>}
                              </div>
                              <div className="qr-label">
                                微信扫码登录
                              </div>
                            </div> */}
                          </div>
                        </div>
                      </Row>
                    </div>
                  </React.Fragment>}
              </>
              <Captcha
                application={application}
                onRef={this.captchaRef}
                handleConfirm={() => this.handleCaptchaConfirm(updatePasswordCheckMsg, updateShipChangePassword, updateSkipPasswordCheck)} />
            </>
          )
        }
      </GlobalContext.Consumer>
    );
  }
}

export default LoginPage;
